import { _IdGenerator } from '@angular/cdk/a11y';
import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { NttDropdownMenu } from './dropdown-menu';

@Directive({
  selector: '[nttDropdownMenuTrigger]',
})
export class NttDropdownMenuTrigger implements OnInit {
  private readonly _elementRef = inject(ElementRef<HTMLElement>);
  private readonly _idGenerator = inject(_IdGenerator);
  private readonly _id = this._idGenerator.getId('ntt-dropdown-trigger-');

  readonly nttDropdownMenuTrigger = input.required<NttDropdownMenu>();

  ngOnInit(): void {
    this._elementRef.nativeElement.style.setProperty(
      'anchor-name',
      `--${this._id}`,
    );
  }

  @HostListener('click')
  protected _onClick(): void {
    const menu = this.nttDropdownMenuTrigger();
    if (menu) {
      menu.setAnchor(this._id);
      menu.toggle();
    }
  }
}
